<mat-select [formControl]="componentFormControl" placeholder="Selecteer Bank">
    <mat-option class="button-select-bank" *ngFor="let bank of banks$ | async" [value]="bank.id">
        {{ bank.name }}
    </mat-option>
</mat-select>
